module.exports = __webpack_public_path__ + "static/img/footer-logo.58e0e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Footer/footer-logo.png
// module id = 836
// module chunks = 0